




















































import { Component, Vue, Inject, Ref, Watch } from 'vue-property-decorator';
import FattorinoList from './FattorinoList.vue';
import FattorinoFilter from './FattorinoFilter.vue';
import { CrudService } from '@/data/services/crud.service';
import { Contatto } from '@/data/models/contatto.model';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { OfferService } from '@/data/services/offer.service';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { UserService } from '@/data/services/user.service';
import { UserStatsRiepilogo } from '@/data/models/userstats.model';
import TopstatsCounter from '@/@core/components/topstats/TopstatsCounter.vue';
import { User } from '@/data/models/user.model';
import FattorinoStats from './fattorino/FattorinoStats.vue';

@Component({
	components: {
		FattorinoList,
		FattorinoFilter,
		ValidationObserver,
		ValidationProvider,
		TopstatsCounter
	},
})
export default class Contatti extends Vue {
	@Inject('CrudService') crudService!: CrudService<Contatto>;
	@Inject('OfferService') offerService!: OfferService;
	@Inject('UserService') userService!: UserService;

	@Ref('list') list!: FattorinoList;
	@Ref('filter') filter!: FattorinoFilter;

	state!: State;

	stats: UserStatsRiepilogo[] = [];

	selected?: User;
	
	constructor() {
		super();
		this.state = store;
	}

	@Watch('state.headquarter', { deep: true })
	onHQChange() {
		this.filter.reset();
		this.loadStats();
	}

	mounted() {
		this.filter.search();
		this.loadStats();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadData();
	}

	loadStats() {
		this.userService.fattoriniStats(this.state.headquarter?.id!).then((result) => {
			this.stats = result;
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	printStats() {
		this.$buefy.modal.open({
			parent: this,
			component: FattorinoStats,
			hasModalCard: false,
			width: 300,
			canCancel: false
		});
	}

}
